export const OfficeRoutes = {
  all: () => '/office',
};
